<template>
    <Space ref="refSpace" :visible="visible" />
    <!-- <Particles ref="refParticles" :visible="visible" /> -->
    <Aurora ref="refAurora" :visible="visible" />
</template>

<script setup>
    import { useThreeOrthoObject } from '#imports';
    import { onBeforeUnmount, onMounted, ref } from 'vue';

    import { disposeObject } from '@resn/gozer-three/helpers';
    import { gsap } from '@resn/gsap';

    // import Aurora1 from './Aurora1/Aurora1.vue';
    import Aurora from './Aurora/Aurora.vue';
    // import Particles from './Particles.vue';
    import Space from './Space.vue';
    import { LIGHTS_DOWN_DUR, LIGHTS_DOWN_REVEAL_START } from '~/core/constants';
    import { useAudio } from '~/providers/AudioProvider';

    const refSpace = ref();
    const refParticles = ref();
    const refAurora = ref();
    const audio = useAudio();

    const visible = ref(false);
    const { object } = useThreeOrthoObject(null, { name: 'LightsDown' });

    const show = ({ delay = 0 } = {}) => {
        const tl = new gsap.timeline({
            delay,
            onStart: () => {
                visible.value = true;
                emit('start');
                audio.play('lightsDownReveal');
            },
            onComplete: () => {
                visible.value = false;
                emit('complete');
            },
        })
            .add(() => refSpace.value?.show(), 1.8)
            .add(() => refParticles.value?.show(), LIGHTS_DOWN_REVEAL_START)
            .add(
                () =>
                    refAurora.value?.show({
                        start: LIGHTS_DOWN_REVEAL_START,
                        end: LIGHTS_DOWN_DUR - 1,
                    }),
                0
            )
            .add(() => {}, LIGHTS_DOWN_DUR);

        return tl;
    };

    onBeforeUnmount(() => {
        disposeObject(object);
    });

    defineExpose({ show });

    const emit = defineEmits(['start', 'complete']);
</script>
